var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"turn"}},[_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.shown),expression:"shown"}],ref:"el",staticClass:"play"},[_vm._v(" Demos page hun ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }